import React from "react";
import VideoContainer from "./VideoContainer";

const MainContainer = () => {
  return (
    <div>
        <VideoContainer />
    </div>
  );
};

export default MainContainer;
